export default __webpack_public_path__ + "static/media/warning--tunnel--g6.db4d3d0f.png";